/** O estado da mesa antes de o servidor responder. Ver `estado.jsx`. */
export const INICIAL = {
  pronto: false,
  usuario: null,
  erroLogin: null,
  /* Quem entrou com senha provisória. Fica FORA de `usuario` de propósito: todo
     efeito que carrega a mesa espera `usuario`, e a portaria recusa o
     escritório até a senha nova — carregar seria uma chuva de 403 atrás da
     tela de troca. */
  trocaDeSenha: null,
  /* Acabou de trocar a senha provisória: a casca leva aos primeiros passos uma
     vez, e esquece. */
  recemChegado: false,
  /* Em que escritório esta aba está, e quais a pessoa alcança. Vem do boot
     (`/api/auth/eu`) porque o `crm_workspace` é COOKIE: sem o nome à vista,
     trocar de escritório numa aba muda o banco de destino das outras. */
  workspace: null,
  workspaces: [],

  mesa: [],
  /* As mensagens que vão num pedido ao assistente (`PedirAoAssistente`). */
  pedindoAoAssistente: null,
  /* As etiquetas que o escritório já usa, com quantos casos cada uma marca.
     Vem de `/api/mesa`, com a lista — contar na tela contaria a página. */
  catalogoDeTags: [],
  numerosDoSetor: [],
  /* O canal de eventos caiu (`GET /api/stream`). A mesa continua desenhada com o
     que já tinha: sem isto a tela ficava com o retrato congelado do WhatsApp e
     ninguém sabia que mensagem nova não chegava mais. */
  canalInstavel: false,
  /*
   * Quantas rajadas de cada tipo de evento já passaram. É o sinal de releitura
   * das vistas que buscam por conta própria.
   *
   * Reuniões, Documentos e Equipe não passam por `carregarVista` — cada uma tem
   * a própria lista, e o tratador de eventos não tinha como avisá-las. O sintoma
   * era mudo: a transcrição terminava, o documento era conferido pelo colega, e
   * a tela seguia mostrando o retrato da abertura. Um contador POR TIPO, e não
   * um só: leitura de pasta não é barata, e Documentos não pode reler o acervo a
   * cada mensagem que chega no WhatsApp.
   */
  pulso: {},
  /* A contagem de cada pastilha, contada pelo BANCO. A tela não tem mais a
     lista inteira para varrer — ver `contadoresDaMesa` em src/leads.ts. */
  contadores: {},
  /* A grade etapa × responsável da mesa, contada pelo BANCO sobre o recorte de
     busca e pastilha — ver `matrizDaMesa` em src/leads.ts. */
  matriz: [],
  matrizInteira: [],
  /* Os três meta-grupos do funil (`aberto | atendendo | concluido`), com o
     rótulo que o domínio escreve — ver `GRUPOS_DA_MESA` em src/leads.ts. */
  gruposDaMesa: [],
  /* Prazo vencido no escritório inteiro. Vem com a mesa e mora aqui porque quem
     acende a pastilha é o trilho, que existe em toda tela. */
  tarefasAtrasadas: 0,
  /* Os atendimentos que a IA conduz agora — chega com a vista de Fluxos. */
  delegadas: [],
  /* Os agentes de IA (personas do atendimento) e os catálogos do editor. */
  agentesIa: [],
  gatilhosIa: [],
  tiposIa: [],
  ferramentasIa: [],
  etapas: [],
  /* Os campos do esquema (chave, rótulo, tipo, ordem), como o escritório os
     configurou. A ficha do painel desenha por eles: sem isso ela imprimia a
     chave crua do banco como rótulo, na ordem em que o JSON caiu. */
  campos: [],
  /* As opções de cada lista de seleção do esquema (tese, origem, motivo…). */
  listas: {},
  equipe: [],
  /** Foto por nome (caixa alta, sem acento) de toda a casa — ver `Rosto`. */
  fotos: {},
  avisos: [],
  /* A lista inteira, da tela de Notificações. `avisos` continua sendo a prévia
     do sino, que chega de carona com a mesa — separar evita a página encolher
     para doze linhas na primeira releitura da mesa. */
  avisosTodos: null,
  envio: "",
  caso: null,
  /* A conexão do WhatsApp. A CAIXA do aparelho saiu junto com a tela dela: a
     fila do celular e o catálogo de contatos eram um lugar à parte da mesa, e
     quem atende trabalha na mesa. Conversa do celular vira atendimento pelo
     lead, não por uma segunda caixa de entrada. */
  conexaoWa: null,
  /* Só provedor + capacidades, o que a mesa recebe. Configurar é em Ajustes. */
  wa: null,
  /*
   * O histórico ANTERIOR ao que a rota agregada manda.
   *
   * `GET /api/mesa/:id` traz as 200 últimas — num atendimento de oito meses as
   * primeiras mensagens, onde o cliente conta o que aconteceu, simplesmente não
   * existiam na tela e ninguém era avisado. A trilha pede os pedaços de trás
   * conforme rola para cima; `antigasFim` é o servidor dizendo que acabou.
   */
  antigas: [],
  antigasFim: false,
  /*
   * O eco do que está saindo: a bolha aparece antes de o servidor confirmar.
   *
   * Enviar era uma ida ao servidor, mais a releitura do caso, mais a da mesa —
   * até tudo voltar a conversa ficava idêntica, e no celular a pessoa aperta
   * Enviar de novo. Cada item é `{ id: "eco-…", texto, quando, entrega, erro,
   * pedido }`; `pedido` é o que o botão "tentar de novo" repete, e é por isso que
   * a falha NÃO perde a mensagem.
   */
  pendentes: [],
  /* Onde a leitura parou quando a conversa abriu — o divisor de não lidas.
     Fixado na abertura porque abrir marca tudo como lido em seguida. */
  naoLidasDesde: null,
  /* Online / digitando / visto por último do cliente. Só o WhatsApp Web manda. */
  presenca: null,
  /* Modo seleção da conversa: os ids marcados para encaminhar ou apagar em lote.
     Nulo é "não está selecionando" — diferente de zero marcadas, que é o modo
     aberto com a barra de pé. */
  selecionadas: null,
  /* A mensagem que a busca está apontando agora, para a bolha piscar. */
  apontada: null,
  /* A mensagem que está sendo citada na resposta. */
  respondendo: null,
  /* A mensagem sendo editada (o texto vai para o campo, como no WhatsApp Web). */
  editando: null,
  /* A mensagem esperando escolha de conversa para encaminhar. */
  encaminhando: null,
  /* O recado de voz sendo gravado para o cliente (não é a reunião). */
  recado_voz: null,
  /*
   * Arquivos escolhidos e AINDA NÃO ENVIADOS, presos ao composer.
   *
   * Antes o clique no clipe abria o seletor e o arquivo saía para o cliente no
   * instante em que a pessoa apertava "Abrir" — sem legenda possível, sem
   * conferir se era o arquivo certo e sem cancelar. É o gesto do WhatsApp que
   * faltava: anexo espera no campo, ganha texto junto e sai no Enviar.
   *
   * Cada item é `{ id, arquivo, nome, tipo, tamanho, url }`. O `url` é
   * `createObjectURL` para a miniatura, revogado ao tirar e ao enviar — blob
   * pendurado é memória que só some recarregando a página.
   */
  anexosPendentes: [],
  /*
   * Para QUEM o composer está escrevendo: `cliente` (vai para o WhatsApp) ou
   * `nota` (fica na trilha, só a equipe lê).
   *
   * É estado do composer e não uma caixa: o texto da nota é escrito no MESMO
   * campo, com a mesma citação e as mesmas respostas prontas. Antes o clique em
   * "nota interna" abria uma caixa de texto por cima da conversa — quem estava
   * com o rascunho começado perdia o contexto de vista para escrever três
   * palavras, e o campo do composer ficava atrás, vazio, parecendo o destino.
   */
  modoComposer: "cliente",
  qrWa: null,
  ia: null,
  provas: [],
  sugestao: null,
  sugestaoIdx: 0,
  sugestaoOculta: false,
  /*
   * O ciclo da IA no caso aberto, ao vivo — o que o palco do atendimento pinta.
   *
   * Vem por evento (`copiloto`/`passo`) e não por releitura: é progresso, não
   * dado, e reler o caso a cada elo do ciclo seria a mesa piscando enquanto o
   * modelo escreve. `parcial` é a mensagem como ela está até agora.
   */
  iaEmAcao: null,

  /*
   * O quadro de tarefas, a agenda e as prontas.
   *
   * Cada uma chega numa ida só (`/api/tarefas`, `/api/agenda`, `/api/rapidas`):
   * contador, carga e prazo saem da MESMA consulta que a lista, porque contar na
   * tela conta a página carregada — foi o erro que a lista da mesa já cometeu
   * ("200 de 200" com 528 no banco).
   */
  tarefas: [],
  contadoresTarefas: {},
  cargaTarefas: [],
  prazosDaSemana: [],
  agendaDias: [],
  contadoresAgenda: {},
  /* O fuso vem do servidor e aparece no cabeçalho da agenda: "20:00" sem dizer
     de onde é a hora vira reunião perdida quando alguém viaja. */
  fusoDaAgenda: null,
  rapidas: [],
  categoriasRapidas: [],
  /* As variáveis que o servidor sabe resolver — a tela não inventa `{nome}`. */
  variaveisRapidas: [],

  fluxos: [],
  autonomia: ["Só sugere", "Envia com revisão", "Envia sozinha"],
  /* O catálogo do que o servidor ESCUTA. Vem de lá porque gatilho é ponto de
     código: lista escrita na tela viraria fluxo com gatilho que ninguém atende. */
  gatilhos: [],
  /* As opções que o servidor entende, por gatilho e por bloco. É o que impede o
     editor de oferecer campo livre onde o domínio espera valor conhecido. */
  catalogos: {},
  motor: null,
  ajustes: {},
  /* O que a Central da IA acrescenta ao catálogo de agentes: as teses com a
     lista de documentos que cada uma cobra, os textos da régua e os freios da
     IA ativa, com a procedência de cada um. */
  tesesDaIa: [],
  cobrancaDaIa: null,
  freiosDaIa: [],
  ambiente: {},
  rascunhoPeca: null,

  /* Qual vista está sendo buscada agora. Sem isto, Fluxos e Caixa decidiam
     entre lista e vazio antes de perguntar ao servidor — e ofereciam "criar o
     primeiro" num escritório com seis fluxos ligados. */
  carregandoVista: null,

  /*
   * Por que o caso da URL não abriu: `{ status, mensagem, daCasa }`.
   *
   * Apagado, arquivado, de outro escritório, sem permissão, sessão caída,
   * servidor mudo — os seis davam a mesma tela ("Carregando…", para sempre),
   * e link de atendimento é justamente o que se manda por mensagem. Nulo é
   * "não há falha", não "não sei"; o `id` diz de qual caso é a falha.
   */
  casoErro: null,

  /* A falha da vista que busca sozinha (fluxos, caixa, ajustes). Sem lugar, o
     erro virava balão de seis segundos e a vista pintava VAZIO por baixo:
     Fluxos oferecia "criar o primeiro" com seis fluxos no banco, e a Caixa
     ficava "lendo o aparelho…" para sempre. */
  erroDaVista: null,

  /* Interface de momento — some ao trocar de tela, não merece URL. */

  /* Muda quando alguém escreve no rascunho por fora (sugestão, resposta pronta):
     é o sinal para o campo de texto se recarregar sem virar campo controlado. */
  sementeRascunho: { texto: "", n: 0 },
};
